import { Grid, makeStyles } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'
import BaseWidget from '../BaseWidget'

const useStyles = makeStyles(theme => ({
  baseWidget: {
    paddingBottom: 0,
    flexGrow: 1,
    display: 'flex'
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  },
  chartContainer: {
    height: '90%',
    width: '90%'
  },
  legend: {
    padding: '20px 0'
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    fontSize: 12
  }
}))

const BarGraphWidgetSkeleton = () => {
  const classes = useStyles()

  return (
    <BaseWidget className={classes.baseWidget} carousel={false}>
      <div className={classes.root}>
        <Grid container className={classes.legend} wrap="nowrap" justifyContent="center">
          {[1].map((_, index) => (
            <div key={index} className={classes.legendItem}>
              <Skeleton variant="circle" width={20} height={20} />
              <Skeleton variant="text" width={80} height={20} style={{ marginLeft: '5px' }} />
            </div>
          ))}
        </Grid>
        <div
          className={classes.chartContainer}
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'flex-end',
            marginBottom: 20,
            width: '50%'
          }}
        >
          <Skeleton variant="rect" width="15%" height="30%" />
          <Skeleton variant="rect" width="15%" height="45%" />
          <Skeleton variant="rect" width="15%" height="60%" />
          <Skeleton variant="rect" width="15%" height="85%" />
        </div>
      </div>
    </BaseWidget>
  )
}

export default BarGraphWidgetSkeleton
